<template>
  <div v-if="manageBroadcastEmailsSteps && manageBroadcastEmailsSteps.length">
    <h1 class="text-2xl sm:text-3xl font-bold text-center mt-6 sm:mt-0">
      How to manage broadcast email settings on www.TheBrokerSite.com
    </h1>

    <p class="mb-10 mt-5 text-gray-600 text-center max-w-2xl mx-auto text-sm sm:text-base">
        Control how you receive broadcast emails by choosing between instant updates or a daily digest per broadcast list, so you only get the updates you need at the right time.
    </p>

    <div class="space-y-8">
      <div v-for="(step, index) in manageBroadcastEmailsSteps" :key="index" class="bg-white p-6 rounded-lg shadow-md">
        <!-- CONTENT -->
        <div class="flex flex-col lg:flex-row items-center gap-8">
          <!-- TEXT (2/5) -->
          <div class="w-full lg:w-2/6">
            <div v-if="step.thumbnail" class=" rounded-xl flex items-center justify-center p-3 bg-white ">
              <img :src="step.thumbnail" class="w-24 object-contain " alt="Step 1 Thumbnail">
            </div>
            <h2 class="text-xl font-bold text-red-700 mb-2 text-center">
              {{ step.title }}
            </h2>
            <p class="text-gray-600 text-sm px-4 text-center leading-5">
              {{ step.description }}
            </p>
          </div>

          <!-- IMAGE (3/5) -->
          <div class="w-full lg:w-4/6 flex justify-center">
            <a :href="step.image" target="_blank" rel="noopener noreferrer">
              <img :src="step.image" :alt="step.title" class="rounded-xl shadow-md border w-full cursor-pointer" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <template>
      <FAQSection :faqs="faqs" />
    </template>
  </div>
</template>

<script>

import FAQSection from '@/components/FAQSection.vue';
import { useSchemaOrg } from '../composables/useSchema.org.js';
import { mapState } from 'vuex';


export default {
  name: 'HowtoManageBroadcastEmails',
  components: {
    FAQSection
  },
  data: () => ({
    manageBroadcastEmailsSteps: [
      {
        title: 'Open Broadcast Settings',
        description: 'Go to the Home or Broadcast page, then click the "More" button. From the menu, select "Broadcast Settings" to open the configuration modal',
        image: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-1.webp',
        thumbnail: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-1-thumbnail.webp'
      },
      {
        title: 'Set email preferences per list',
        description: 'Set your email preference for each broadcast list. Choose No Email, Standard for instant emails, or Digest for a daily summary of broadcasts.',
        image: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-2.webp',
        thumbnail: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-2-thumbnail.webp'
      },
      {
        title: 'Save broadcast settings',
        description: 'Click Save Settings to apply your changes.',
        image: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-3.webp',
        thumbnail: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-3-thumbnail.webp'
      },
      {
        title: 'Confirmation message',
        description: 'A success message will confirm that your broadcast settings were updated.',
        image: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-4.webp',
        thumbnail: 'https://www.thebrokersite.com/images/help/manage_broadcast_emails/manage-broadcast-notification-step-4-thumbnail.webp'
      }
    ]
  }),
  mounted() {
    const helpSchema = {
      "@context": "https://schema.org",
      "@type": "HowTo",
      name: "How to manage broadcast email settings on www.TheBrokerSite.com",
      description: "Control how you receive broadcast emails by choosing between instant updates or a daily digest per broadcast list, so you only get the updates you need at the right time.",
      image: this.manageBroadcastEmailsSteps.map(step => step.image),

      step: this.manageBroadcastEmailsSteps.map((step, index) => ({
        "@type": "HowToStep",
        name: step.title,
        text: step.description,
        image: step.image,
        position: index + 1
      })),

      mainEntity: {
        "@type": "FAQPage",
        mainEntity: this.faqs.map(faq => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer
          }
        }))
      }
    };
    useSchemaOrg(helpSchema);
  },
  computed: {
    ...mapState(['frequentlyAskedQuestions']),
    faqs() {
      return this.frequentlyAskedQuestions['how_to_manage_broadcast_email']
    }
  }
}
</script>
